import { Box } from '@mui/material';
import { getCategoryColor, getImageURLCategoryListIcon } from '../utils/utils';
import { AppColor, Fonts } from '../types/Constants';
import { useAppSelector } from "../utils/hooks";
import ImageLoader from './ImageLoader';
import { useEffect, useState } from 'react';

type Props = {
    category?: string;
    fontSize?: string;
    padding?: string;
    minWidth?: string;
    borderRadius?: string;
    justifyContent?: string;
    id?: string;
    icons?: boolean;
    selected?: boolean;
    hover?: boolean;
    lastModfied?: string;
    color?: string;
    localImage?: File | null;
    error?: boolean;
}

const BeaconCategory = ({ category, fontSize, padding, minWidth, borderRadius, justifyContent, id, icons = false, selected, hover = false, lastModfied, color, localImage, error }: Props) => {

    const categoryGroupState = useAppSelector((state) => state.category);

    const [imageFilterURL, setImageFilterURL] = useState<string>("");

    const backgroundColor = color 
    ? (color.startsWith("#") ? color : `#${color}`) 
    : (category ? getCategoryColor(category, categoryGroupState.categories ?? []) : AppColor.componentBackground);

    const textColor = backgroundColor === "#ffffff" ? "silver" : "white";

    useEffect(() => {
        let objectUrl = "";

        if (localImage) {
            objectUrl = URL.createObjectURL(localImage);
            setImageFilterURL(objectUrl);
        } else {
            setImageFilterURL(getImageURLCategoryListIcon(id ?? "", lastModfied ?? ""));
        }

        return () => {
            if (objectUrl) {
                URL.revokeObjectURL(objectUrl);
            }
        };
    }, [localImage, id, lastModfied]);

    return (<Box
        sx={{
            color: textColor,
            backgroundColor: backgroundColor,
            padding: padding ? padding : '0px 8px',
            border: error ? "2px solid #d32f2f" : selected ? "2px solid black" : "2px solid transparent",
            borderRadius: borderRadius ? borderRadius : '5px',
            minWidth: minWidth ? minWidth : "100px",
            display: 'flex',
            justifyContent: justifyContent ? justifyContent : "center",
            alignItems: "center",
            whiteSpace: 'nowrap',
            fontSize: fontSize ? fontSize : "14px",
            fontWeight: Fonts.MEDIUM,
            ...(hover && {
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'scale(1.02)',
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
                },
              }),
            paddingLeft: "4px"
        }}>
        {icons && (
            <ImageLoader 
                imageURL={imageFilterURL}
                height="25px"
                width="25px"
                mr="6px"
                borderRadius='50%'
            />
        )}
        {category}
    </Box>
    );
};

export default BeaconCategory;
